"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./EyebrowPromo.css");

var _helperUtil = require("../common/util/helperUtil");

var _constants = require("../constants");

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !_construct.default) return false;
    if (_construct.default.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call((0, _construct.default)(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = (0, _construct.default)(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

var EyebrowPromo = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(EyebrowPromo, _React$Component);

  var _super = _createSuper2(EyebrowPromo);

  function EyebrowPromo(props) {
    var _this;

    (0, _classCallCheck2.default)(this, EyebrowPromo);
    _this = _super.call(this, props);
    _this.toggleStickyEyebrow = _this.toggleStickyEyebrow.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(EyebrowPromo, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.showStickyEyebrow()) {
        this.toggleStickyEyebrow();

        if (typeof window !== 'undefined') {
          window.addEventListener('scroll', this.toggleStickyEyebrow);
        }
      }
    }
  }, {
    key: "showStickyEyebrow",
    value: function showStickyEyebrow() {
      var location = typeof window !== 'undefined' ? window.location : {};
      var hostName = (0, _helperUtil.getDomainUrl)(_constants.BRANDS.SHUTTERFLY);

      if (hostName === location.origin && location.pathname === '/' || typeof window !== 'undefined' && typeof window.useStickyEyebrow !== 'undefined' && !window.useStickyEyebrow || !this.props.useStickyEyebrow) {
        return false;
      }

      return true;
    }
  }, {
    key: "toggleStickyEyebrow",
    value: function toggleStickyEyebrow() {
      var eyebrowEle = typeof document !== 'undefined' ? document.querySelector('#uig-eyebrow-promo') : undefined;

      if (eyebrowEle) {
        var scrollY = typeof window !== 'undefined' ? window.scrollY || window.pageYOffset : 0;
        var eyebrowPosition = eyebrowEle.getBoundingClientRect().top;
        eyebrowPosition += scrollY - 40;
        var headerHeightEle = typeof document !== 'undefined' && document.querySelector('.uig-nav-bar-wrapper');

        if (scrollY > eyebrowPosition) {
          eyebrowEle.classList.add('uig-sticky-eyebrow');
        }

        if (headerHeightEle) {
          var headerHeight = headerHeightEle.offsetHeight + (typeof window !== 'undefined' ? window.innerWidth < 992 ? 110 : 50 : 50);

          if (scrollY <= headerHeight) {
            eyebrowEle.classList.remove('uig-sticky-eyebrow');
          }
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.hideEyebrowPromo) {
        return null;
      }

      return _react.default.createElement("div", {
        id: "uig-eyebrow-promo-wrapper"
      }, this.props.eyebrowPromoData.__html && _react.default.createElement("div", {
        id: "uig-eyebrow-promo",
        className: this.props.className,
        dangerouslySetInnerHTML: this.props.eyebrowPromoData
      }));
    }
  }]);
  return EyebrowPromo;
}(_react.default.Component);

EyebrowPromo.propTypes = {
  eyebrowPromoData: _propTypes.default.object.isRequired,
  hideEyebrowPromo: _propTypes.default.bool,
  className: _propTypes.default.string,
  useStickyEyebrow: _propTypes.default.bool
};
EyebrowPromo.defaultProps = {
  hideEyebrowPromo: false,
  className: '',
  useStickyEyebrow: true
};
var _default = EyebrowPromo;
exports.default = _default;